import { ReactNode, useState } from 'react';
import cn from 'classnames';

//Utils
import { MakeRequired } from '~utils/typescriptHelpers';
//Icons
import EyeIcon from '~icons/EyeIcon';



type FloatingLabelPasswordFieldProps =
    MakeRequired<
        Omit<JSX.IntrinsicElements['input'], 'checked' | 'placeholder'>,
        'name'
    > & {
    label: ReactNode,
    register: any,
    defaultValue?: string | number,
    isDirty: boolean,
    isInvalid: boolean,
    isTouched: boolean,
    error?: string
};


export default function FloatingLabelPasswordField({label, name, defaultValue, isDirty, isTouched, isInvalid, error, register, id, ...rest}: FloatingLabelPasswordFieldProps) {
    const [isVisible, setIsVisible] = useState(false);

    const toggleVisibility = () => setIsVisible((prevIsVisible) => !prevIsVisible);

    return (
        <div className={cn('floating-label with-icon', {'is-required': rest.required, 'is-dirty': isDirty, 'is-touched': isTouched, 'is-invalid': isInvalid})}>
            <input
                name={name}
                type={isVisible ? 'text' : 'password'}
                defaultValue={defaultValue}
                className="floating-label__input"
                placeholder=" "
                id={id}
                {...rest}
                {...register(name)}
            />

            <label htmlFor={id}>{label}</label>
            <div className="floating-label__border"/>
            <EyeIcon className="floating-label__icon" onClick={toggleVisibility}/>

            {error && <div className="floating-label__error">{error}</div>}
        </div>
    );
}
